export enum ESameDayNoticePeriod {
	THREE_HOURS = 3,
	FOUR_HOURS = 4,
	FIVE_HOURS = 5,
	SIX_HOURS = 6,
	SEVEN_HOURS = 7,
	TEN_HOURS = 10,
	TWELVES_HOURS = 12,
}
